<script setup lang="ts">
import {defineAsyncComponent, onBeforeMount, ref} from "vue";
import ReportViewerPlace from "@/utils/presenters/ReportViewerPlace.ts";
import ReportLauncherPlace from "@/utils/presenters/ReportLauncherPlace.ts";
import {DashboardWidgetProps, ReportPopupContainer} from "@/utils/presenters/interfaces.ts";

const AsyncReportLauncher = defineAsyncComponent(() => import("@/views/ReportLauncher.vue"))
const AsyncReportViewer = defineAsyncComponent(() => import("@/views/ReportViewer.vue"))
import CustomRepInfo = namaTypes.CustomRepInfo;
import EditScreenReport = namaTypes.EditScreenReport;

const props = defineProps<DashboardWidgetProps>();

const viewer = ref();
const launcher = ref();
let placeCreated = ref(false);

let place: ReportViewerPlace | ReportLauncherPlace;
let repoInfo: CustomRepInfo | undefined = props.chartLine.repoInfo;

if (repoInfo?.launchType === 'DirectInPopup')
  place = new ReportViewerPlace();
else
  place = new ReportLauncherPlace();

place.reportId = repoInfo ? repoInfo.reportId : '';
let block: EditScreenReport = {
  reportInfo: repoInfo,
  title: {
    arabicText: props.chartLine.arChartTitle ?? '',
    englishText: props.chartLine.enChartTitle ?? ''
  }
}
const popupContainer: ReportPopupContainer = {
  block: block,
  currentMode: ref(repoInfo?.launchType === 'DirectInPopup' ? 'view' : 'launch'),
  place: place
};

onBeforeMount(async () => {
  await start();
  placeCreated.value = true;
});

async function start() {
  if (viewer.value)
    viewer.value.rerun(popupContainer.place);
  else if (launcher.value)
    launcher.value.rerun(popupContainer.place);
}
</script>

<template>
  <div class="tw-min-h-full tw-h-full tw-bg-namaBackground-bright-light dark:tw-bg-namaBackground-bright-dark tw-rounded">
    <template v-if="placeCreated">
      <div
        class="tw-min-h-full tw-h-full tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-overflow-auto">
        <template v-if="popupContainer.currentMode.value === 'view' && popupContainer.place instanceof ReportViewerPlace">
          <AsyncReportViewer :popupContainer="popupContainer" ref="viewer"/>
        </template>
        <template v-else-if="popupContainer.currentMode.value === 'launch' && popupContainer.place instanceof ReportLauncherPlace">
          <AsyncReportLauncher :popupContainer="popupContainer" ref="launcher"/>
        </template>
      </div>
    </template>
  </div>
</template>

<style scoped>

</style>
